import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import ListTemplate from "@/templates/PromptTemplate/ListTemplate";
import useBossBabyPromptTemplateList from "./useBossBabyPromptTemplateList";

/**
 * 보스베이비 프롬프트 템플릿 목록 페이지
 *
 * @description 보스베이비 채팅에서 사용하는 프롬프트 템플릿을 관리하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default function BossBabyPromptTemplateListPage() {
  const {
    data,
    loading,
    categories,
    selectedCategory,
    searchKeyword,
    handleCategoryChange,
    handleSearch,
    handleCreate,
    handleDetail,
    handleDelete,
  } = useBossBabyPromptTemplateList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          보스베이비 프롬프트 관리
        </Typography>
        <Button variant="contained" startIcon={<Add />} onClick={handleCreate}>
          Create Template
        </Button>
      </Box>

      <ListTemplate
        data={data}
        loading={loading}
        categories={categories}
        selectedCategory={selectedCategory}
        searchKeyword={searchKeyword}
        onCategoryChange={handleCategoryChange}
        onSearch={handleSearch}
        onDetail={handleDetail}
        onDelete={handleDelete}
      />
    </Container>
  );
}









